// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { Link } from "react-router-dom";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import Seo from "../Seo/SeoComponent";
import BlogSubscribePrompt from "../NewsletterForm/BlogSubscribePrompt";
import { blogPosts } from "../../consts/blogPosts";
import styles from "./blogPage.module.scss";

function formatDate(dateString) {
    return new Date(`${dateString}T00:00:00`).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

function BlogPage() {
    const posts = [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : -1));

    return (
        <div className={styles.page}>
            <Seo
                title="Blog"
                description="Tips, explanations, and notes on learning to read, write, and type Japanese."
                path="/blog"
            />
            <Header />

            <main className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>Blog</h1>
                    <p className={styles.description}>
                        Tips, explanations, and notes on learning to read, write, and type Japanese.
                    </p>
                    <a href="/rss.xml" className={styles.rssLink}>
                        RSS feed
                    </a>

                    <div className={styles.postList}>
                        {posts.map((post) => (
                            <Link key={post.slug} to={`/blog/${post.slug}`} className={styles.postCard}>
                                <div className={styles.postMeta}>
                                    <time dateTime={post.date}>{formatDate(post.date)}</time>
                                    {post.tags?.map((tag) => (
                                        <span key={tag} className={styles.postTag}>
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                                <h2 className={styles.postTitle}>{post.title}</h2>
                                <p className={styles.postExcerpt}>{post.excerpt}</p>
                                <span className={styles.readMore}>Read more →</span>
                            </Link>
                        ))}
                    </div>

                    <BlogSubscribePrompt />
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default BlogPage;
